export default __webpack_public_path__ + "static/media/R6No5.1ce38334.mp3";